<template lang="pug">
  .container.grid-lg
    form.pb-2.list-filters(@submit.prevent='listar')
      .columns.align-end
        .column.col-auto
          .form-group
            small {{ 'ordem_servico_solicitacao.usuario_solicitou' | tModel }}
            fiscal-picker(v-model="q.usuario_solicitou_id_eq" sm)
        .column.col-auto
          .form-group
            small {{ 'usuario.grupo' | tModel }}
            usuario-grupo-picker(v-model="q.usuario_solicitou_usuario_grupo_id_eq" sm)
        .column.col-auto
          .form-group
            small {{ 'ordem_servico_solicitacao.situacao' | tModel }}
            select.form-select.select-sm(v-model="q.situacao_eq")
              option(:value="null") Todos
              option(v-for="label, value in $i18n.t('enums.db.enum_ordem_servico_solicitacao_situacao')" :value="value") {{ label }}
        .column.col-auto
          button.btn.btn-action.s-circle.btn-sm
            i.fa.fa-filter
    load-manager(:status="status")
      div(v-if='list.length > 0')
        table.table.table-striped.table-hover.table-sm
          thead
            tr
              th {{ 'ordem_servico_solicitacao.ordem_servico' | tModel }}
              th {{ 'ordem_servico.created_at' | tModel }}
              th {{ 'ordem_servico.fiscal_ciente_em' | tModel }}
              th {{ 'ordem_servico.concluir_em' | tModel }}
              th {{ 'ordem_servico_solicitacao.usuario_solicitou' | tModel }}
              th {{ 'ordem_servico_solicitacao.solicitado_concluir_em' | tModel }}
              th {{ 'ordem_servico_solicitacao.situacao' | tModel }}
              th
          tbody.text-small
            tr(v-for="row in list" :key='row.id')
              td
                span(v-if='row.ordem_servico') {{ row.ordem_servico.numero }}/{{ row.ordem_servico.ano }}
              td
                span(v-if='row.ordem_servico') {{ row.ordem_servico.created_at | date }}
              td
                span(v-if='row.ordem_servico') {{ row.ordem_servico.fiscal_ciente_em | date }}
              td
                span(v-if='row.ordem_servico') {{ row.ordem_servico.concluir_em | date('DD/MM/YYYY') }}
              td {{ row.usuario_solicitou.nome }}
              td {{ row.solicitado_concluir_em | date }}
              td
                span(:class='classSituacao(row.situacao)') {{ row | enums('ordem_servico_solicitacao.situacao') }}
              td
                a.c-hand(@click='solicitacao = row')
                  btn-icon(name='show')
      .empty.mt-2(v-else)
        .empty-icon
          i.icon.icon-search
        p.empty-title.h5 Nenhum Registro encontrado

    .my-2.text-right(v-if='pages > 1')
      btn-paginate(:page='page', :pages='pages', :count='count', @go-page='goPage', @prev-page='prevPage', @next-page='nextPage')
    div(v-if='solicitacao')
      modal-acao(:solicitacao='solicitacao' :active='Boolean(solicitacao)' @close='solicitacao = null')
</template>

<script>
import { vuexDefaultMapping } from '@/mixins/list'
import ModalAcao from './ModalAcao'

export default {
  vuex: { solicitacoes: vuexDefaultMapping },

  components: { ModalAcao },

  data() {
    return {
      q: { situacao_eq: 'solicitado' },
      solicitacao: null,
    }
  },

  methods: {
    listar() {
      this.setQuery({ ...this.q })
      this.setPage(1)
      this.fetchList()
    },
    classSituacao(situacao) {
      switch (situacao) {
        case 'autorizado':
          return 'text-success'
        case 'recusado':
          return 'text-error'
        default:
          return 'text-primary'
      }
    },
  },

  created() {
    this.q = { ...this.q, ...this.query }
    if (!this.list || this.list.length === 0) {
      this.listar()
    }
  },
}
</script>
